import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';

import { getParticipantsAction } from '../../../services/request';
import { ParticipantList } from './participant/ParticipantList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

export const ParticipantRecord = () => {
  const [pageSettings, setPageSettings] = React.useState({ page: 1, pageSize: 10, search: null });
  const { loading, payload, error, query } = useQuery(getParticipantsAction(pageSettings.page, pageSettings.pageSize, pageSettings.search));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [participants, setParticipants] = React.useState([]);
  const [count, setCount] = React.useState(0);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');

  React.useEffect(() => {
    if (!loading && !error) {
      setParticipants(payload.results);
      setCount(payload.count);
    }
  }, [loading]);

  const queryCallback = (pageD, pageSize, search = null) => {
    const page = pageD + 1;
    setPageSettings({ page, pageSize, search });
    query(pageSettings.page, pageSettings.pageSize, pageSettings.search);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setParticipants(
        _.map(participants, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setParticipants(_.filter(participants, obj => obj.id !== obj2.id));
    } else {
      setParticipants([obj2, ...participants]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <ParticipantList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        participants={participants}
        count={count}
        queryCallback={queryCallback}
        submitCallback={submitCallback} />
    </>
  );
};
